import { useTranslation } from 'react-i18next'
import { SetupWizardStep, SetupWizardStepComponent } from 'app/menu/components/TopBarV1/setupWizard/SetupWizardStep'
import { useDispatch } from 'react-redux'
import AddLocationIcon from '@mui/icons-material/AddLocation'
import { updateValidateShopDetailsStepRequest } from '@cbgms/api/modules/shops/requests'
import N from 'utils/navigation'

export const ContactInformationCTA: SetupWizardStepComponent = props => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  return (
    <SetupWizardStep
      {...props}
      step={{
        icon: <AddLocationIcon />,
        content: t('SetupWizard.ShopDetailsSummary'),
        buttonText: t('SetupWizard.ShopDetailsCTA'),
        actionOnClick: () => {
          N.push(`/settings/my-shop`)
          dispatch(updateValidateShopDetailsStepRequest(false))
        }
      }}
    />
  )
}
